module.exports = __webpack_public_path__ + "img/american-samoa.e46b65c0.svg";